export default __webpack_public_path__ + "static/media/yellow-horn.a09bd792.png";